import { createSeniorFlowTab } from './seniorFlowTabFactory';
import { completedInterviewColumn } from './CompletedInterviewCell';
import { panelVerdictColumn } from './PanelVerdictCell';
import { registerTab } from './tabRegistry';

// senior_level_flow — "Completed" tab (shown to the TA as "Final Call", per
// the flow-statuses API's own tabs[].name — a real GET response confirms
// this tab's filters.status is just ["Completed"] on its own now, not
// merged with "Shortlisted" as an earlier sample suggested; "Shortlisted"
// is its own separate is_final state/tab — see SeniorShortlistedTab.jsx.
// manual_actions: forward_to_cse ("shortlist" this candidate onward to the
// CSE-facing side of the pipeline), reject.
//
// The reference design for this tab (screening-pipeline-v6.html's "Final
// call") also shows an interview score and per-interviewer notes — neither
// exists on the candidate-list API's row.completed_interview_rounds, so
// those stay out. What it DOES now carry is a per-round aggregate tally
// (round_number, interview_time, verdict_counts: {advance, reject, hold,
// pending}), which backs the two columns below: when they were interviewed,
// and how the panel's votes on that round currently read. See
// CompletedInterviewCell.jsx / PanelVerdictCell.jsx for the column
// implementations and their own notes on picking the latest round when a
// candidate has more than one.
const SeniorCompletedTab = createSeniorFlowTab(
  'Completed',
  'No candidates have completed this stage yet.',
  { extraColumns: [completedInterviewColumn, panelVerdictColumn] }
);

registerTab({
  stateMachineKey: 'senior_level_flow',
  state: 'Completed',
  component: SeniorCompletedTab,
});

export default SeniorCompletedTab;
